module.exports = __webpack_public_path__ + "static/img/dybg_jcjg_icon_pulse.png";